var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"full-mask-wrap",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"MIDAS-TOAST-loading MIDAS-TOAST-loading-demand"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }